import React, { ReactElement } from "react";
import clsx from "clsx";
import { ChevronDownIcon, CloseIcon, ErrorIcon, IconProps } from "../Icon";
import Button from "../atomic/Button";

interface RegisterStepProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  children: React.ReactElement<any>;
  title: string;
  description?: string;
  onNext?: () => void;
  onPrev?: () => void;
  icon: ReactElement<IconProps>;
  showNavigation?: boolean;
  prevText?: string;
  nextText?: string;
}

function RegisterStep({
  children,
  className,
  onNext,
  nextText,
  prevText,
  onPrev,
  icon,
  showNavigation = true,
  ...props
}: RegisterStepProps) {
  const hasNav = showNavigation && (prevText || nextText);
  return (
    <div className={clsx("flex flex-col py-4 min-w-0", className)}>
      {React.cloneElement(children, { onNext, onPrev, ...props })}
      {hasNav && (
        <div className="flex items-center justify-between mt-8 pt-5 border-t border-gray-100 dark:border-gray-700 gap-3">
          {prevText ? (
            <button
              type="button"
              onClick={onPrev}
              className="flex items-center gap-1.5 px-4 py-2.5 rounded-xl border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 text-sm font-semibold hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
            >
              <ChevronDownIcon viewBox="0 0 34 34" className="transform rotate-90" size={4} />
              {prevText}
            </button>
          ) : (
            <span />
          )}
          {nextText && (
            <button
              type="button"
              onClick={onNext}
              className="flex items-center gap-1.5 px-4 py-2.5 rounded-xl bg-primary text-white text-sm font-semibold hover:bg-primary-600 transition-colors"
            >
              {nextText}
              <ChevronDownIcon viewBox="0 0 34 34" className="transform -rotate-90" size={4} />
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default RegisterStep;
